type Props = {
  children: string
  className?: string
  reverse?: boolean
}

const PageTitle = ({ children, className, reverse }: Props) => {
  return (
    <h2
      className={`${
        reverse ? '' : 'ml-4'
      } text-xl leading-normal md:text-2xl lg:text-3xl ${className}`}
    >
      {children}
    </h2>
  )
}

export default PageTitle
